{
  "Empty": "Leer"
}
